import { j as e } from "../../../../jsx-runtime-CQ7OqOhn.js";
import * as t from "@radix-ui/react-select";
import s from "../../../../utilities/tw.js";
import a from "../../../../tailwindConfig/bclTwMerge.js";
const u = ({
  children: o,
  value: r,
  isCurrentlySelected: c
}) => {
  const m = s`cursor-pointer px-4 py-2 font-medium focus:bg-secondary-hover focus:outline-none`, n = s`bg-secondary-active`;
  return /* @__PURE__ */ e.jsx(
    t.Item,
    {
      className: a(
        m,
        c && n
      ),
      value: r,
      children: /* @__PURE__ */ e.jsx(t.ItemText, { children: o })
    }
  );
};
export {
  u as default
};
